import { createContext, useContext } from "react";

interface MenuItemProps {
	destructive?: boolean;
}
const MenuItemContext = createContext<MenuItemProps>({
	destructive: false,
});
export const useMenuItemContext = () => {
	return useContext(MenuItemContext);
};

export default MenuItemContext;
